export default __webpack_public_path__ + "static/media/card-project3.10fe3724.jpg";